module.exports = __webpack_public_path__ + "media/img/event/TQ-ace-bbef557c1965510f5bfaa226cd446049.png";